














import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import { Book } from './../model/book_model'
import { knowledgeManage } from './../model/api'
import { getUrlParams } from '@/utils/urlUtils'

@Component
export default class KnowledgeTree extends Vue {
  @Prop() public checkable!: boolean
  @Prop({
    default() {
      return 3
    }
  })
  public maxKps!: number
  @Prop({
    default() {
      return {
        checked: [],
        halfChecked: []
      }
    }
  })
  public propFactors!: { checked: string[] | number[]; halfChecked: string[] | number[] }
  @Prop({
    default() {
      return true
    }
  })
  private selectable!: boolean

  public treeData = []
  public loadedKeys = []
  public limitThreeTimes: boolean = false
  public factors: { checked: string[] | number[]; halfChecked: string[] | number[] } = {
    checked: [],
    halfChecked: []
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  public get getFactors() {
    return this.$store.state.question.factors
  }
  @Watch('subjectId')
  onSubejctChange(val) {
    this.getKonwledgeCatalog()
  }
  @Watch('factors', { deep: true })
  onFactorsChange(val, old) {
    // console.log(val.checked)
    if (val.checked.length > this.maxKps) {
      alert(`最多可以选取${this.maxKps}个知识点哦！`)
      this.factors = old
      return
    }
    this.$store.commit('SET_FACTORS', val) // 使用vuex
    this.onCheck(val) // 不使用vuex
  }
  @Watch('getFactors', { deep: true })
  onGetFactorsChange(val, old) {
    if (this.isObjectValueEqual(val, old)) {
      return
    } else {
      this.factors = val
    }
  }
  // 单选时
  @Emit()
  check(val) {
    return val
  }
  // 多选时
  @Emit()
  onCheck(val) {
    return val
  }
  public mounted() {
    this.getKonwledgeCatalog()
  }
  /**
   * onLoadData
   */
  public async onLoadData(treeNode: any) {
    let { data } = await knowledgeManage({
      parent_id: -1 === treeNode.dataRef.key.indexOf('?') ? '' : treeNode.dataRef.key.split('?')[0],
      subject_id: this.subjectId
    })

    return new Promise((resolve) => {
      if (treeNode.dataRef.children) {
        resolve()
        return
      }
      if (!data || !data.length) {
        treeNode.dataRef.isLeaf = true
        this.treeData = [...this.treeData]
        resolve()
        return
      }
      treeNode.dataRef.children = this.treeDataProcess(data)
      this.treeData = [...this.treeData]
      resolve()
    })
  }
  public treeDataProcess(data) {
    let temp: any = []
    if (data && data.length > 0) {
      for (let n of data) {
        let item: any = {}
        item.class = n.class || ''
        item.style = n.style || ''
        item.disableCheckbox = n.disableCheckbox || false
        item.disabled = n.disabled || false
        item.icon = n.icon || ''
        item.isLeaf = !n.has_child || false
        item.key = n._id + `?title=${n.name}` || ''
        item.title = n.name || ''

        // 是否可选
        if (!this.selectable) {
          item.selectable = false
        }

        temp.push(item)
      }
    }
    return temp
  }
  public async getKonwledgeCatalog(id?: string) {
    let { data } = await knowledgeManage({
      parent_id: id,
      subject_id: this.subjectId
    })
    this.treeData = this.treeDataProcess(data)
  }
  public onSelect(val) {
    if (!this.checkable) {
      this.check(val)
    }
  }
  // 判断两个对象内容是否一致
  public isObjectValueEqual(a, b) {
    let aProps = Object.getOwnPropertyNames(a)
    let bProps = Object.getOwnPropertyNames(b)

    if (aProps.length != bProps.length) {
      return false
    }

    for (var i = 0; i < aProps.length; i++) {
      let propName = aProps[i]
      if (a[propName] !== b[propName]) {
        return false
      }
    }

    return true
  }
}
